// extracted by mini-css-extract-plugin
export var block = "footerDetails-module--block--b3XeS";
export var br = "footerDetails-module--br--wVaV4";
export var button = "footerDetails-module--button--KOZ91";
export var description = "footerDetails-module--description--9jGwi";
export var hide = "footerDetails-module--hide--7b0a1";
export var redButton = "footerDetails-module--redButton--8sIzz";
export var text = "footerDetails-module--text--DmgS9";
export var wrapperLarge = "footerDetails-module--wrapperLarge--3b78c";
export var wrapperSmall = "footerDetails-module--wrapperSmall--4k9RV";